// src/pages/ComingSoonPage.jsx
import React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import { WEBSITE_NAME } from '../utils/constants';
import '../styles/pages/ComingSoonPage.css';

const ComingSoonPage = () => {
  return (
    <div className="coming-soon-page">
      <Header />
      
      <main className="coming-soon-main">
        <div className="coming-soon-content">
          <div className="coming-soon-badge">🚧 Coming Soon</div>
          
          <h1 className="coming-soon-title">This page is under construction</h1>
          
          <p className="coming-soon-description">
            We're working hard to bring you amazing new features and content. 
            This section of {WEBSITE_NAME} will be available soon!
          </p>
          
          <div className="notification-box">
            <h3 className="notification-title">Notify Me When It's Ready</h3>
            <div className="notification-form">
              <input 
                type="email" 
                placeholder="Enter your email address" 
                className="notification-input"
              />
              <button className="notification-button">Notify Me</button>
            </div>
            <p className="notification-note">We'll send you one email when this page launches.</p>
          </div>
          
          <div className="action-buttons">
            <a href="/" className="home-button">← Back to Home</a>
            <a href="#pricing" className="pricing-button">View Pricing</a>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ComingSoonPage;